<template lang='pug'>
div
  el-table(:data='invoices', v-loading='invoices == null')
    el-table-column(type='expand')
      template(slot-scope='props')
        invoice(:invoice-summary='props.row')

    el-table-column(label='Date', width='140')
      template(slot-scope='scope')
        div
          i.mat-icon.secondary date_range
          |  {{$formatDate(scope.row.delivery_date)}}

    el-table-column(label='Customer')
      template(slot-scope='scope')
        | {{scope.row.customer_account_name}}
        br
        .secondary Order \#{{scope.row.order_id}}

    el-table-column(label='Event')
      template(slot-scope='scope')
        strong {{ scope.row.request_name }}
        div(v-if='scope.row.vendor_name') {{ scope.row.vendor_name }}
        .secondary Invoice \#{{ scope.row.id }}

    el-table-column(label='Total', width='90')
      template(slot-scope='scope')
        div
          | {{$formatCents(scope.row.total_cents)}}
        small
          strong {{sourceToString(scope.row.payment_source)}}

    el-table-column(label='Balance', width='90')
      template(slot-scope='scope')
        div {{$formatCents(scope.row.balance_cents)}}

    el-table-column(label='Status')
      template(slot-scope='scope')
        status-tag(:status='scope.row.status')

    el-table-column(label='Actions')
      template(slot-scope='scope')
        el-dropdown(class='order-list__dropdown')
          span(class='el-dropdown-link')
            | Choose action
            i(class='el-icon-arrow-down el-icon--right')
          el-dropdown-menu(slot='dropdown' class='order-list__dropdown-menu')

            el-dropdown-item(v-if='scope.row.status == "PENDING_PAYMENT" ')
              el-button(type='text', @click='openPaymentModal(scope.row)')
                | Make Payment

            el-dropdown-item()
              el-button(type='text', @click='openTipsModal(scope.row)')
                | Add tips

            el-dropdown-item(v-if='scope.row.id!= null')
              el-button(type='text', @click='$openInBlank(`/print/invoices/${scope.row.id}`)')
                | Invoice Summary&nbsp;
                span.mat-icon open_in_new
            el-dropdown-item(v-if='scope.row.order_id!= null')
              el-button(type='text', @click='$openInBlank(`/print/orders/${scope.row.order_id}`)')
                | Invoice Detailed&nbsp;
                span.mat-icon open_in_new
            el-dropdown-item(v-if='scope.row.order_id!= null')
              el-button(type='text')
                  router-link(:to="'/staff/payments/' + scope.row.id") Payments&nbsp;
            el-dropdown-item(v-if='scope.row.payment_source != "OFFLINE" && scope.row.status == "PENDING_PAYMENT" ')
              el-button(type='text', @click='retryDialog(scope.row.id)')
                | Retry

  scheduler(:invoice='invoiceOnSchedule', :visible.sync='displayScheduler',
  v-if='displayScheduler')
  el-col()
    el-pagination( 
        v-if="pagination.pages > 1"
        @current-change="onPaginationChange"
        :page-size="pagination.per_page", 
        :pager-count="pagination.pages", 
        layout="prev, pager, next", 
        :total="pagination.total")   
  router-view
</template>

<script>

  import StatusTag from '../../common/StatusTag.vue'
  import Scheduler from './Scheduler.vue'
  import Invoice from './Invoice.vue'

  function data(){
    return {
      invoices: null,
      displayScheduler: false,
      invoiceOnSchedule: null,
      pagination: {
        per_page: null,
        current: null,
        pages: null,
        total: null,
      }
    }
  }

  function onPaginationChange(current_page){
    this.getData(current_page);
  }

  function created(){
    this.getData()
  }

  function retryDialog(id){
    const title = "Retry invoice payment"
    const msg = "A new attempt to charge the customer's card will be made. Continue?"
    this.$confirm(msg, title, {
      confirmButtonText: 'Charge card',
      cancelButtonText: 'Cancel',
      type: 'warning'
    }).then(() => {
      this.retry(id)
    }).catch(() => { })
  }

  function openPaymentModal (row) {
    this.$router.push({ path: '/staff/invoices/payment', query: { id: row.id, balance: row.balance_cents } })
  }

  function openTipsModal (row) {
    this.$router.push({ path: '/staff/invoices/tips', query: { id: row.id, balance: row.balance_cents } })
  }

  function scheduleDialog(invoice){
    this.invoiceOnSchedule = invoice
    this.displayScheduler = true
  }

  function retry(id){
    const target = `/invoices/${id}/retry`
    this.$simplecater.post(target).then(r => {
      this.$message("The payment was processed")
      this.getData()
    }).catch((e)=>{
      // TODO improve message because only a generic error comes back
      const msg = "Failed to process payment."
      this.$message.error(msg)
    })
  }

  function schedule(id){
    this.$message("PENDING WIRING")
  }

  function goToInvoice(id){
    this.$router.push(`/invoices/${id}`)
  }

  function goToDelivery(id){
    this.$router.push(`/deliveries/${id}`)
  }

  function getData(current_page){
    let reqParams = (current_page ?{params:{ page:current_page}}:{params:{}});
    if(this.sorting){
      this.$isNumber(this.sorting)?reqParams.params.id=this.sorting:reqParams.params.q=this.sorting
    }

    this.$simplecater.get(this.targetUri,reqParams).then((r)=>{
      this.invoices = r.data.data;
      this.pagination = r.data.pagination;
    }).catch(()=>{
      this.$message.error('Failed to load data')
    })
  }

  function sourceToString(source){
    if (source == "OFFLINE") return "Check"
    return "Stripe"
  }

  const watch = {
    sorting: function(){
      this.getData();
    },
    filter: function(newFilter){
      console.log("FILTER FROM TO", this.filter, newFilter)
    },
    $route: function() {
      this.getData();
    }
  }

  const computed = {
    targetUri: function(){
      if(this.filter == 'all'){
        return '/invoices'
      }else{
        return `/invoices/${this.filter}`
      }
    }
  }

  const components = {
    StatusTag, Scheduler, Invoice
  }

  const methods = {
    getData, onPaginationChange, retry, retryDialog, sourceToString, openPaymentModal, openTipsModal
  }

  const props = {
    filter: { required: true },
    sorting:{ required: false }
  }

  export default { methods, components, data, created, watch, props, computed }
</script>



// WEBPACK FOOTER //
// src/staff/blocks/InvoiceList.vue